<template>
    <v-container>
        <Titulo></Titulo>
        <div class="text-center">
            <h4 v-if="screen > 800" style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 20px; line-height: 25px; letter-spacing: -0.01em;
                color: #2D387C;"> ¡Oh no! {{ userData.name }}, lo sentimos, ha ocurrido un error inesperado.
            </h4>
            <h4 v-else style="margin: auto; width: 80%; margin-top: 8% !important; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 20px; line-height: 25px; letter-spacing: -0.01em;
                color: #2D387C;"> ¡UPS! HA OCURRIDO UN ERROR INESPERADO.
            </h4>
        </div>

        <br>
        <br>

        <div :class="image">
            <v-card flat tile>
                <v-img contain max-height="300" :src="ErrorImage" max-width="300" style="margin:auto;" />
            </v-card>
        </div>

        <br>
        <br>

        <div :class="card">
            <v-card class="text-center">
                <div style="padding-top: 2%;padding-bottom: 2%;">
                    <label :class="errorMessage">
                    Al parecer ocurrio un error con el sistema de
                    pago, pero no <br> te preocupes que debe ser
                    temporal.
                </label>
                </div>
            </v-card>
        </div>

        <br><br>

        <div class="text-center">
            <v-btn style="padding: 12px 15px; gap: 10px; width: 270px; height: 50px; background: #2A3881; box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
                        border-radius: 24px; text-transform:inherit; color: white;" elevation="0"
                @click="returnPage()">
                Volver a pagos
            </v-btn>
        </div>

    </v-container>
</template>

<script>
import Titulo from "../components/Titulo.vue";
import ErrorImage from "@/assets/images/Error.png";
import CryptoJS from 'crypto-js';

export default {
    components: { Titulo },
    data() {
        return {
            secretKey: process.env.VUE_APP_CRYPT,
            image: null,
            card: null,
            ErrorImage,
            screen: window.screen.width,
            userData: {
            name: null,
            surname: null,
            serialNumber: null,
            rut: null,
            region: null,
            commune: null,
            regionCode: null,
            comuneCode: null,
            address: null,
            email: null,
            phoneNumber: null,
            couponId: null,
            hasAcode: null,
            stepId: null,
            old: null,
            day: null,
            month: null,
            year: null,
            dates: null,
            typePlan: null,
            PlanName: null,
            datesBenef: null,
            errorMessage: null,
            sonExist: false,
            },
        }
    },
    async mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        document.body.setAttribute('data-sku', 'APS-008-ERR');

        const userDataAux = sessionStorage.getItem('userData');
        const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
        const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
        this.userData = JSON.parse(decryptedDataUser);

        if (this.screen > 800) {
            this.image = 'image';
            this.card = 'card';
            this.errorMessage = 'errorMessage';
        } else {
            this.image = 'image2';
            this.card = 'card2';
            this.errorMessage = 'errorMessage2';
        }
    },
    methods: {
        returnPage(){
            this.$router.push({ path: '/ap/resumen' })
        }
    }

}
</script>

<style lang="css" scoped>
.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.image {
    width: 20%;
    margin: auto;
}

.image2 {
    width: 68%;
    margin: auto;
}
.card {
    width: 40%;
    margin: auto;
}

.card2 {
    width: 100%;
    margin: auto;
    border: 1px solid #B5B5B5;
}
.errorMessage{
    font-family: Arial; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 15px; 
    line-height: 20px; 
    text-align: center; 
    color: #232323; 
    opacity: 0.75;
}
.errorMessage2{
    font-family: Arial; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 15px; 
    line-height: 20px; 
    text-align: center; 
    color: #232323; 
    opacity: 0.75;
    width: 72%;
    display: flex;
    margin: auto;
}
</style>
